<!-- eslint-disable vue/multi-word-component-names -->

<script>
  export default {
    props: {
      outlined: {
        type: Boolean,
        default: false,
      },
      maxHeight: {
        type: String,
        default: 'auto',
      },
      height: {
        type: String,
        default: 'auto',
      },
      isActive: {
        type: Boolean,
        default: false,
      },
      isDisabled: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>
<template lang="">
  <section
    :style="{ maxHeight, height }"
    class="box box-bg"
    :class="{
      'box-outlined': outlined,
      'box-filled': !outlined,
      'box-max_height': !!maxHeight,
      'box-active': isActive,
      'box-disabled': isDisabled,
    }"
  >
    <slot></slot>
  </section>
</template>
<style lang="scss">
  .box {
    border-radius: 0.5rem;
    padding: 1rem;
    &-filled {
      background-color: var(--background-color);
    }
    &-outlined {
      border: 1px solid var(--v-darkColor-base);
    }
    &-max_height {
      overflow-y: auto;
    }
    &-active {
      background-color: var(--background-color);
      border: 1px solid var(--v-darkColor-base);
    }
    &-disabled {
      background-color: #f9f9f9 !important;
      border: none !important;
    }
  }
</style>
